import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const faqs = [
  {
    q: "How accurate is this?",
    a: "Every scan runs real-time API calls to ChatGPT (via OpenAI) and Google Search (via SerpAPI). AI responses can vary by prompt, timing, and location. That's why we show the exact query and response as evidence. Results are cached briefly for performance, but each unique scan is a fresh query.",
  },
  {
    q: "How is this different from other SEO tools?",
    a: "Most SEO tools check Google rankings. AILens also checks whether AI platforms recommend your brand. We run 4 technical checks specific to AI crawlers: scanning your robots.txt for GPTBot, ClaudeBot, and PerplexityBot access, not just Googlebot. Few tools offer this, and AILens does it for free.",
  },
  {
    q: "What if I score low?",
    a: "A low score means there's a gap between your Google rankings and your AI visibility. Now you know about it. The scan includes specific recommendations to help you improve. Most brands score lower than expected on their first scan.",
  },
];

const LandingFAQ = () => {
  const ref = useScrollReveal();

  return (
    <section ref={ref} className="py-10 md:py-16 px-4 bg-secondary/30">
      <div className="max-w-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-8">
          Common questions
        </h2>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-border">
              <AccordionTrigger className="text-left text-foreground font-semibold text-base hover:no-underline">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground leading-relaxed">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default LandingFAQ;
